import React from "react";
import {useHasPermission} from "../../hooks/permission";

const DeleteButton = ({  onDelete, permission }) => {
    const hasAccess = useHasPermission(permission);

    if(permission && !hasAccess){
        return '';
    }

    return (
        <button
            onClick={onDelete}
            type="button"
            className="btn btn-outline-secondary deleterow"
        >
            <i className="icofont-ui-delete text-danger"></i>
        </button>
    );
};

export default DeleteButton;